import { BaseService, RequestType } from "@intech/react-service";
import { SitPlanoEntidade } from "../entidades";

class SituacaoPlano extends BaseService {

  constructor() {
    super("sitPlano");
  }

  BuscarTodas = () =>
    this.CreateRequest<Array<SitPlanoEntidade>>(RequestType.GET);

}

export const SituacaoPlanoService = new SituacaoPlano();